(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bolero-how"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bolero-how]').forEach(section=>{const button=section.querySelector('[data-how-pause]');button.addEventListener('click',()=>{const paused=section.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));});new IntersectionObserver(entries=>section.classList.toggle('is-in-view',entries[0].isIntersecting),{threshold:.15}).observe(section);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bolero-instagram"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bolero-carousel]').forEach(section=>{const track=section.querySelector('[data-ig-track]');const button=section.querySelector('[data-ig-pause]');const videos=[...track.querySelectorAll('[data-ig-video]')];let paused=false;let hover=false;let visible=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');const refreshVideos=()=>{const bounds=track.getBoundingClientRect();const winner=videos.find(video=>{const box=video.getBoundingClientRect();return Math.min(box.right,bounds.right)-Math.max(box.left,bounds.left)>box.width*.7;});videos.forEach(video=>{if(video!==winner||!visible||paused||document.hidden||reduced.matches){video.pause();return;}if(!video.src){video.src=video.dataset.src;video.muted=true;}if(video.paused)video.play().catch(()=>{});});};const move=direction=>{const card=track.querySelector('.b-ig-post');if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);const end=track.scrollWidth-track.clientWidth;let left=track.scrollLeft+direction*step;if(left>end-3)left=direction>0&&track.scrollLeft>=end-3?0:end;if(left<0)left=end;track.scrollTo({left,behavior:reduced.matches?'instant':'smooth'});};button.addEventListener('click',()=>{paused=!paused;button.setAttribute('aria-pressed',String(paused));refreshVideos();});section.querySelector('[data-ig-next]').addEventListener('click',()=>{move(1);});section.querySelector('[data-ig-prev]').addEventListener('click',()=>{move(-1);});track.addEventListener('pointerenter',()=>hover=true);track.addEventListener('pointerleave',()=>hover=false);track.addEventListener('focusin',()=>hover=true);track.addEventListener('focusout',()=>hover=false);track.addEventListener('pointerdown',()=>{hover=true;});track.addEventListener('pointerup',()=>{hover=false;});let frame=0;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(refreshVideos);},{passive:true});document.addEventListener('visibilitychange',refreshVideos);reduced.addEventListener('change',refreshVideos);new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;refreshVideos();},{threshold:.2}).observe(section);const timer=setInterval(()=>{if(!section.isConnected){clearInterval(timer);videos.forEach(v=>v.pause());return;}if(visible&&!paused&&!hover&&!document.hidden&&!reduced.matches)move(1);},9000);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bolero-launch-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
 const updateLaunchBanners = () => {
  document.querySelectorAll('[data-bolero-launch-banner]').forEach(banner => {
   const expiresAt = Number(banner.dataset.expiresAt);
   if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    banner.hidden = true;
    return;
   }
   if (banner.dataset.expiryReady === 'true') return;
   banner.dataset.expiryReady = 'true';
   window.setTimeout(() => {
    delete banner.dataset.expiryReady;
    updateLaunchBanners();
   }, Math.min(expiresAt - Date.now(), 2147483647));
  });
 };
 if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateLaunchBanners, {once:true});
 } else {
  updateLaunchBanners();
 }
 document.addEventListener('shopify:section:load', updateLaunchBanners);
 window.addEventListener('pageshow', updateLaunchBanners);
 document.addEventListener('visibilitychange', () => {
  if (!document.hidden) updateLaunchBanners();
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
